<script setup lang="ts">
  import { IconRadio } from '@/shared/ui';
  import { TRAINING_TYPE_LABELS, type TrainingType } from '@/entities/Training';

  const CREATABLE_TRAINING_TYPES = Object.keys({
    ONBOARDING: true,
    ROLE_CHANGE: true,
    SGQ_DOCUMENT_FOCAL: true,
    OPEN_TRAINING: true,
  } satisfies Record<Exclude<TrainingType, 'SGQ_DOCUMENT_HOMOLOGATION'>, true>) as TrainingType[];

  defineProps<{
    modelValue: TrainingType | null;
  }>();

  defineEmits<{
    (e: 'update:modelValue', value: TrainingType): void;
  }>();
</script>

<template>
  <div class="flex flex-wrap gap-8">
    <IconRadio
      v-for="type in CREATABLE_TRAINING_TYPES"
      :key="type"
      :data-testid="`training-type-radio-${type}`"
      :model-value="modelValue ?? undefined"
      :value="type"
      :label="TRAINING_TYPE_LABELS[type]"
      name="training-type"
      class="!font-medium"
      @update:model-value="$emit('update:modelValue', $event as TrainingType)"
    />
  </div>
</template>
